/* import __COLOCATED_TEMPLATE__ from './help-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();